import SmartIceLogo from './logos/smart-ice-logo.png'
import PolarViewLogo from './logos/polar-view-logo.png'
import LookNorthLogo from './looknorthlogosmaller.png'
import ArcticCrowdSourceLogo from './logos/arctic-crowd-source-logo.png'
import { getBrand } from '../selectors/brandSelector'

const logos = {
  'SmartIce': SmartIceLogo,
  'PolarView': PolarViewLogo,
  'LookNorth': LookNorthLogo,
  'ArcticCrowdSource': ArcticCrowdSourceLogo
}

const Logo = logos[getBrand()]

export default Logo



// WEBPACK FOOTER //
// ./src/assets/logo.js